import { usePromotion } from '@mc/promo-utils'
import { useGiftEnabled } from '../../../lib/helpers'

export const useExperimentCriteria = () => {
  const { giftEnabled } = useGiftEnabled()
  const { isPromotionOn } = usePromotion()

  return { experimentCriteria: isPromotionOn && !!giftEnabled }
}
